import React from "react";
import { Button, Typography, Box } from "@mui/material";
import VisuallyHiddenInput from "../VisuallyHiddenInput";

const HorizontalPosterUpload = ({
  posterPreviews,
  handlePosterFilesChange,
  formik,
}) => {
  return (
    <Box>
      {posterPreviews.length > 0 &&
      posterPreviews.some((poster) => poster.name === "large") ? (
        <img
          src={posterPreviews.find((poster) => poster.name === "large")?.url}
          alt="Poster preview"
          style={{
            width: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        (formik.values.type === "WATCH" || formik.values.type === "DEVOTION") && (
          <>
            <Typography margin={"10px 0px"} component={"p"}>
              Add Key Poster (Horizontal)
            </Typography>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              sx={{ width: "100%", padding: "10px" }}
            >
              Upload file
              <VisuallyHiddenInput
                accept="image/jpeg, image/png, image/gif"
                type="file"
                name="large"
                onChange={handlePosterFilesChange}
              />
            </Button>
          </>
        )
      )}
    </Box>
  );
};

export default HorizontalPosterUpload;
